module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('OrderDetailHeader', {
    attrs: {
      "orderData": _vm.order,
      "payShow": _vm.payDialogShow
    },
    on: {
      "payShowClose": _vm.payShowClose,
      "payShowSuccess": _vm.payShowSuccess,
      "payShowError": _vm.payShowError
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-box"
  }, [(_vm.order.open_seller_fenxiao == 2) ? _c('div', {
    staticClass: "row-title"
  }, [_c('img', {
    staticClass: "row-title-img",
    attrs: {
      "src": _vm.order.business_pic_url,
      "alt": ""
    }
  }), _vm._v("\n      " + _vm._s(_vm.order.business_name) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.order.items), function(goods, index) {
    return _c('div', {
      staticClass: "row-between"
    }, [_c('div', {
      staticClass: "between-left"
    }, [_c('img', {
      staticClass: "between-left-img",
      attrs: {
        "src": goods.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "between-right"
    }, [_c('div', {
      staticClass: "flex-between"
    }, [_c('div', {
      staticClass: "between-left-title"
    }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), (goods.is_comment == 2 && _vm.order.order_status == 2 && _vm.order.pay_status == 2 && _vm.order.express_status == 3) ? _c('van-tag', {
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "plain": "",
        "type": "danger",
        "round": "",
        "size": "medium"
      },
      on: {
        "click": function($event) {
          return _vm.onOrderComment(goods.goods_id)
        }
      }
    }, [_vm._v("评价")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "between-left-detail gray-light"
    }, [_vm._v(_vm._s(goods.sku.sku_formart))]), _vm._v(" "), _c('div', {
      staticClass: "between-sku"
    }, [_c('div', {
      staticClass: "between-left-price"
    }, [_vm._v("¥" + _vm._s(goods.goods_price_base))]), _vm._v(" "), _c('div', {
      staticClass: "between-sku-right"
    }, [_c('div', {
      staticClass: "between-right-num gray-light"
    }, [_c('span', [_vm._v("数量")]), _vm._v("\n                " + _vm._s(goods.count) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "between-right-btn",
      on: {
        "click": function($event) {
          return _vm.onExpressTrace(goods)
        }
      }
    }, [_vm._v("物流跟踪")])])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row-title"
  }, [_vm._v("客户备注：" + _vm._s(_vm.order.buyer_note))])], 2), _vm._v(" "), _c('div', {
    staticClass: "row-message"
  }, [_c('div', {
    staticClass: "message-title"
  }, [_vm._v("物流信息")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("收货地址")]), _vm._v(" "), (_vm.order.address) ? _c('div', {
    staticClass: "message-right gray-light"
  }, [_c('div', {
    staticClass: "address-pro"
  }, [_vm._v(_vm._s(_vm.order.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "address-phone"
  }, [_vm._v(_vm._s(_vm.order.address.name) + " " + _vm._s(_vm.order.address.phone))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row-message"
  }, [_c('div', {
    staticClass: "message-title"
  }, [_vm._v("订单信息")]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("订单号")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("\n        " + _vm._s(_vm.order.code) + " |\n        "), _c('span', [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.order.code),
      expression: "order.code",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("复制")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v(_vm._s(_vm.order.create_time_str))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("支付时间")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v(_vm._s(_vm.order.pay_time_str))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("订单价格")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.order_price))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("运费")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.express_price))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("优惠")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.discount_price))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("改价")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.fix_price))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("应付金额")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.pay_price))])]), _vm._v(" "), _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("已付金额")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("￥" + _vm._s(_vm.order.payed_price))])])]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.express,
      "cancel-text": "取消"
    },
    on: {
      "select": _vm.onSelect,
      "cancel": _vm.onCancel
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('div', {
    staticClass: "add-b-b"
  }, [_c('van-button', {
    staticStyle: {
      "background": "#ee0a24",
      "border-color": "#ee0a24",
      "padding": "0 0.8rem"
    },
    attrs: {
      "round": "",
      "type": "info"
    },
    on: {
      "click": _vm.onServiceApply
    }
  }, [_vm._v("发起售后")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("快递")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-li"
  }, [_c('div', {
    staticClass: "message-left"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "message-right gray-light"
  }, [_vm._v("微信在线支付")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78ea1ff6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/PartnerOrderDetail.vue
// module id = 2481
// module chunks = 0